export default {
    getters: {
        token(state) {
            return !!state.token;
        },
        userEmail(state) {
            return state.userEmail;
        },
        userFullName(state) {
            return state.userFullName;
        },
        userRoleName(state) {
            return state.userRoleName
        },
        snackbar(state) {
            return state.snackbar
        }
    },
    state: {
        token: localStorage.getItem('token') || '',
        userEmail: '',
        userFullName: '',
        userRoleName: '',
        snackbar: {
            show: false,
            message: '',
            color: ''
        }
    },
    mutations: {
        setUserEmail(state, userEmail) {
            state.userEmail = userEmail
        },
        setUserFullName(state, userFullName) {
            state.userFullName = userFullName
        },
        setUserRoleName(state, userRoleName) {
            state.userRoleName = userRoleName
        },
        setSnackbar(state, snackbar) {
            state.snackbar = snackbar
        }
    },
    actions: {
        async logOut({ commit }) {
            const snackbar = {
                show: true,
                message: "Выход прошел успешно",
                color: 'success'
            }
            commit('setSnackbar', snackbar)
            localStorage.removeItem('token')
        },
        async logIn({ commit, dispatch }, { login, password }) {
            try {
                const response = await dispatch('apiRequest', {
                    endpoint: "token",
                    method: "POST",
                    data: { login: login, password: password },
                });

                const responseData = await response.json();

                if (response.status === 400) {
                    const snackbar = {
                        show: true,
                        message: responseData.detail,
                        color: 'error'
                    }
                    // console.log('snackdata ' + snackbar)
                    commit('setSnackbar', snackbar)

                } else if (response.status === 200) {
                    localStorage.setItem('token', responseData.token);
                    const snackbar = {
                        show: true,
                        message: 'Авторизация прошла успешно',
                        color: 'success'
                    }
                    location.reload()
                    commit('setSnackbar', snackbar)
                } else {
                    const snackbar = {
                        show: true,
                        message: 'Ошибка, статус код ' + response.status,
                        color: 'error'
                    }
                    commit('setSnackbar', snackbar)
                }
            } catch (error) {
                // console.log(error.message)
                const snackbar = {
                    show: true,
                    message: "Внутренняя ошибка сервера",
                    color: 'error'
                }
                commit('setSnackbar', snackbar)
            }
        },
        async checkToken({ commit, dispatch }, { layout }) {
            const savedToken = localStorage.getItem('token');

            const response = await dispatch('apiRequest', {
                endpoint: "verify_token",
                method: "POST",
                headers: { token: savedToken },
            });
            if (response.status !== 200) {
                localStorage.removeItem("token")
                const snackbar = {
                    show: true,
                    message: "Время сессии истекло",
                    color: 'error'
                }
                commit('setSnackbar', snackbar)
                if (layout !== 'login') {
                    location.reload()
                }
            }
            const responseData = await response.json();
            if (responseData.valid_token === false) {
                const snackbar = {
                    show: true,
                    message: "Время сессии истекло",
                    color: 'error'
                }
                commit('setSnackbar', snackbar)
                localStorage.removeItem("token")
                // console.log(layout)
                if (layout !== 'login') {
                    location.reload()
                }
            } else {
                commit('setUserEmail', responseData.email)
                commit('setUserFullName', responseData.full_name)
                commit('setUserRoleName', responseData.role_name)
            }
        }
    }
}
